module.exports = "/_next/static/images/ev-charging-solutions-c70d3591edff129d887c5c8bad5f8044.webp";